const getMessages = (t) => ({
  FIELD_REQUIRED: t('Field required.'),
  CITY_REQUIRED: t('Select a valid city.'),
  FIELD_MIN_LENGTH: (length) => t('This field cannot be less than {{length}} chars.', { length }),
  EMAIL_INVALID: t('Email invalid.'),
});

export default getMessages;
